import React, { useEffect, useRef, useState } from "react";
import { COLOR_GRAY_BANNER_BACKGROUND } from "../../constants/general-constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import UtilisationFloorPlanChartPanel from "./components/UtilisationFloorPlanChartPanel";
import UtilisationFloorPlanFloorPanel from "./components/UtilisationFloorPlanFloorPanel";
import UtilisationFloorPlanTimeline from "./components/UtilisationFloorPlanTimeline";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../../constants/general-constants";

export default function UtilisationFloorPlan({}){

  const thisContainer = {display: "flex",position: "fixed",flexDirection: "column",width: "100%",minHeight: "100vh",left: "0px",top: "0px",};
  const mainContainer = {display: "flex",position: "fixed",top: "80px",left: "60px",bottom: "0px",right: "0px",overflow: "auto",};
  const floorPanel = {display: "flex",width: "calc(100% - 300px)",flexDirection: "column"};
	const chartContainer = {display:"flex",width:"300px",flexDirection:"column",height:"calc(100vh - 80px)"};
	const mainToolBar = {flexDirection:'column', padding:'10px', display:'flex', position:'fixed',zIndex:'4',bottom:'20px',left:'80px', right:'320px', backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,borderRadius:'6px',height:'80px',boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)'}
	const mainToolBarTop = {display:'flex', width:'100%'};
	const playIconContainer = {backgroundColor:SYSTEM_BLUE_BACKGROUND_LIGHT, display:'flex', marginTop:'0px', marginLeft:'10px', marginRight:'10px', borderRadius:'20px', height:"40px", width:'40px', alignItems:'center', justifyContent:'space-around'};
	const playIcon = {display:'flex', width:'20px', height:'20px', color:'white'}
	const dataSelector = {marginTop:'15px', marginLeft:'10px', display:'flex', alignItems:'center', width:'100%', flexDirection:'row'};
	const dataSelectorRadio = {display:"flex", width:'15px', height:'15px', borderRadius:'8px'};
	const dataSelectorText = {display:'flex', marginLeft:'5px', marginTop:'2px', marginRight:'20px', color:'white', fontSize:'14px'};

  return (
    <div style={thisContainer}>
      <Header />
      <LeftMenu />
      <div style={mainContainer}>
        <div style={floorPanel}>
        <UtilisationFloorPlanFloorPanel/>
        </div>
        <div style={chartContainer}>
      		<UtilisationFloorPlanChartPanel/>
      	</div>
      </div>
      <div style={mainToolBar}>
      	<div style={mainToolBarTop}>
      		<UtilisationFloorPlanTimeline/>
      		<div style={playIconContainer}>
      			<FontAwesomeIcon icon="pause" style={playIcon}/>
      		</div>
      	</div>
      	<div style={dataSelector}>
      		<input type="radio" style={dataSelectorRadio} name="dataselector"/>
      		<div style={dataSelectorText}>
      			Heatmap Bubbles
      		</div>
      		<input type="radio" style={dataSelectorRadio} name="dataselector"/>
      		<div style={dataSelectorText}>
      			Colour By Activity
      		</div>
      		<input type="radio" style={dataSelectorRadio} name="dataselector"/>
      		<div style={dataSelectorText}>
      			Show Sensors
      		</div>
      		<input type="radio" style={dataSelectorRadio} name="dataselector"/>
      		<div style={dataSelectorText}>
      			Capacity Bubbles
      		</div>
      	</div>
      </div>
    </div>
  );
}






















